/* Copyright (c) 2022 Xperi. All Rights Reserved. */

import { GuideRow as IGuideRow, GuideCell as IGuideCell } from 'client-code/grid-guide';
import { GuideCell } from './GuideCell';

export class GridGuideRow {
    /**
     * Station ID for a given guide row.
     * @type {string}
     */
    stationId: string;

    /**
     * Array of guide cells for a given guide row.
     * @type {Array<GuideCell>}
     */
    guideCells: Array<GuideCell>;

    constructor(data: IGuideRow, imageHostBaseUrl: string) {
        this.stationId = data.stationId;
        this.guideCells = data.guideCells.map(
            (guideCell: IGuideCell): GuideCell => new GuideCell(guideCell, imageHostBaseUrl),
        );
    }
}
